import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  outer: {
    position: "relative",
    "@media(max-width: 1024px)": {
      display: "none"
    }
  },
  toc: {
    position: "sticky",
    top: "16px",
    borderLeft: `1px solid ${theme.palette.divider}`,
    "& p": {
      margin: "0px 0px 4px",
      fontSize: "0.8125rem!important"
    },
    "& ul": {
      listStyle: "none",
      margin: 0,
      padding: 0,
      paddingLeft: "16px",
      "& li": { fontSize: "0.8125rem!important", lineHeight: 1.6 },
      "& a": {
        textDecoration: "none",
        color: theme.palette.text.primary,
        fontWeight: 500,
        transition: theme.transitions.create(["color"], {
          easing: theme.transitions.easing.easeInOut,
          duration: theme.transitions.duration.shortest
        }),
        "&:hover": { color: theme.app.linkHoverColor }
      },
      "& a.active": { color: theme.palette.secondary.main }
    }
  },
  tocHeader: {
    fontSize: "0.8125rem",
    padding: "0 8px",
    color: theme.palette.text.secondary
  }
}));

const Toc = ({ toc, activeHash }) => {
  const classes = useStyles();
  useEffect(() => {
    const links = document.querySelectorAll("li a");
    links.forEach(l => {
      l.classList.remove("active");
      if (l.hash === activeHash) {
        l.classList.add("active");
      }
    });
  }, [activeHash]);
  return (
    <div className={classes.outer}>
      <div className={classes.toc}>
        {toc.length > 0 && (
          <Typography className={classes.tocHeader}>
            PÅ DEN HÄR SIDAN
          </Typography>
        )}
        <div dangerouslySetInnerHTML={{ __html: toc }} />
      </div>
    </div>
  );
};

export default Toc;
